import { render } from "./GoogleIcon.vue?vue&type=template&id=0b854b50&ts=true"
import script from "./GoogleIcon.vue?vue&type=script&lang=ts"
export * from "./GoogleIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__